export const locale = {
    lang: 'en',
    data: {
      'Headers': {
          'ChooseFile': 'Choose File',
          'NoFileSelected': 'No File Selected',
          'BeforeImages': 'Before Images',
          'AfterImages': 'After Images',
          'AllImages': 'All Images'
      },
      'orderByStatus':{
        'value1':'Date ↑',
        'value2':'Date ↓'
      },
      'FILTERS': {
        'SEARCH': 'Search',
        'SORTING_STATUS': 'Sort Status',
        'Search_Start_Date': 'Search Start Date',
        'Search_End_Date': 'Search End Date',
        'Folder_Type': "Folder Type"
      }
    }
  };
  